<pre class="w-100 pre-container" data-uit="log-code"><code>{{formattedLog}}</code></pre>
